import { ObjectGroupsModal, ObjectGroupType } from '@europrocurement/flexy-components';
import React, { useEffect, useState } from 'react';
import { useFormaliteService } from '@europrocurement/l2d-domain';

export type DossierSearchGroupProps = {
    selectedItems: Array<ObjectGroupType>;
    allowSubmit: boolean;
    submitting?: boolean;
    onSubmit: (data: ObjectGroupType) => void;
    onCreate: () => void;
};

const DossierSearchGroup: React.FunctionComponent<DossierSearchGroupProps> = function (props) {
    const {
        selectedItems,
        allowSubmit,
        submitting,
        onSubmit: handleSubmit,
        onCreate: handleCreate,
    } = props;
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [objectGroups, setObjectGroups] = useState<Array<ObjectGroupType>>([]);

    const { dossierOpenSearchApi } = useFormaliteService();
    let searchObjectGroupTimeout: number | undefined;

    const getGroups = (term: string) => {
        setLoading(true);
        clearTimeout(searchObjectGroupTimeout);
        searchObjectGroupTimeout = setTimeout(() => {
            dossierOpenSearchApi
                .apiOpensearchObjectGroupsGetCollection({ q: term })
                .then((res) => {
                    const fetchObjectGroups = res.data[
                        'hydra:member'
                    ] as unknown as Array<ObjectGroupType>;

                    setObjectGroups(fetchObjectGroups);
                    setLoading(false);
                })
                .catch((error) => {
                    setObjectGroups([]);
                    setLoading(false);
                    console.log(error.message);
                });
        }, 300);
    };

    useEffect(() => {
        if (loading === false) {
            getGroups(searchTerm);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    return (
        <ObjectGroupsModal
            title="Déplacer le dossier dans un groupe"
            createButtonLabel="Créer un nouveau groupe de dossiers"
            submitButtonLabel="Déplacer"
            onSubmit={handleSubmit}
            search={(term) => setSearchTerm(term)}
            objectGroups={objectGroups}
            onCreate={handleCreate}
            loading={loading}
            selectedIds={selectedItems.filter((item) => item).map((item) => item.id)}
            enableSubmit={allowSubmit}
            submitting={submitting}
        />
    );
};

export default DossierSearchGroup;
